import { useQuery } from "@tanstack/react-query";

import { makeApiRequest } from "../../utils";
import { BULLMQ_QUEUES_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchBullMQQueues = () => {
  return useQuery({
    queryKey: [BULLMQ_QUEUES_QUERY_KEY],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: "/api/bullmq/queues",
        method: "GET"
      });
    },
    refetchInterval: 5000 // Refresh every 5 seconds
  });
};
